import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { logout } from './logout';

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_BASE_URL_PROD
      : process.env.REACT_APP_API_BASE_URL_DEV,
});

// Request Interceptor – Check Token Expiry
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);

      if (decoded.exp && decoded.exp < now) {
        logout(); // call the centralized logout
        return Promise.reject(new Error('Token expired'));
      }

      config.headers.Authorization = `Bearer ${token}`;
    } catch (err) {
      logout(); // logout on invalid token
      return Promise.reject(err);
    }
  }

  return config;
});

// Response Interceptor – Catch server-side 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Do not treat aborted/canceled requests as auth failures
    if (error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    // Do NOT logout on 401 from login route
    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest.url?.includes('/auth/login')
    ) {
      logout();
    }

    return Promise.reject(error);
  }
);

// const isAuthRoute = ['/auth/login', '/auth/check-captcha'].some(path =>
//   originalRequest.url.includes(path)
// );

// if (error.response?.status === 401 && !isAuthRoute) {
//   logout();
// }


export default api;
